import TestReportManagerDialog from './TestReportManagerDialog';

export default TestReportManagerDialog; 